export class Prices {
  static DEFAULT_PRICE = '9999';

  static price(price: number | string | undefined): string {
    if (Number(price) === 0) {
      return this.DEFAULT_PRICE;
    }
    return (price || this.DEFAULT_PRICE).toString();
  }
}
